import styled from 'styled-components';
import { PaginationItemMixin } from '../../mixins/components/PaginationItemMixin';

/**
 * Used by the `Pagination` component to house the page number buttons based on `PaginationButton`.
 *
 * @since 7.42.0
 */
var PaginationNumberItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "PaginationNumberItem",
  componentId: "c11n-8-107-0__sc-i6f8qs-0"
})(["", ""], PaginationItemMixin);
PaginationNumberItem.displayName = 'PaginationNumberItem';

/** @component */
export { PaginationNumberItem };